import React from 'react';

const MarkenTableComponentLoadable = React.lazy(() => import('./MarkenTableComponent'));
const MarkenFormComponentLoadable = React.lazy(() => import('./MarkenFormComponent/MarkenFormComponent'));

export {
    MarkenTableComponentLoadable,
    MarkenFormComponentLoadable
};